import { type Pagination, type PaginationData, type ProgramListItem, createProgramList } from 'models';
import { useInfiniteQuery } from 'query';
import { getPrograms } from '../services';
import type { ProgramsListFilter } from '../types';
import { getProgramsInfiniteQueryKey } from './keys';

type P = {
  filter?: ProgramsListFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useProgramsInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<PaginationData<ProgramListItem>, string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const response = await getPrograms({
        config: {
          params: {
            cursor,
            featured: filter?.featured,
            limit: pagination.pageSize,
            organization_id: filter?.organizationId,
            scope: filter?.scope,
            search: filter?.search,
            status: filter?.status,
            user_id: filter?.userId,
            view: 'table',
          },
        },
      });

      return {
        data: response.data.data.map((programDataObject) => createProgramList(programDataObject)),
        total: response.data.total,
      };
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage, allPages) {
      if (allPages.length * pagination.pageSize >= lastPage.total) {
        return undefined;
      }

      return lastPage.data.at(-1)?.id;
    },
    queryKey: getProgramsInfiniteQueryKey({ filter, pagination }),
  });
